import React, { useState } from "react";

const EditProductModal = ({ product, onClose, onSave }) => {
  const [serialNumber, setSerialNumber] = useState(product.product_serial_number);
  const [description, setDescription] = useState(product.product_description);
  const [error, setError] = useState("");

  const validateSerialNumber = (serial) => {
    const regex = /^(\d{5})-(\d{2})(\d{2})-(\d{4})$/;
    return regex.test(serial);
  };

  const handleSave = async () => {
    if (!validateSerialNumber(serialNumber)) {
      setError("Invalid serial number format. Use XXXXX-YYWW-BBBB.");
      return;
    }

    const updatedProduct = { ...product, product_serial_number: serialNumber, product_description: description };

    try {
      const response = await fetch(
        `https://sucmhxbjlk.execute-api.us-east-1.amazonaws.com/prod/product/edit/${product.id}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updatedProduct),
        }
      );

      if (response.ok) {
        onSave(updatedProduct);
        onClose();
      } else {
        setError("Failed to save changes.");
      }
    } catch (error) {
      setError("An error occurred while saving.");
    }
  };

  return (
    <div className="modalContainer">
      <div className="modalBackdrop">
        <div className="modalPopup modalWide">
          <h2>Edit Product</h2>
  
          {/* Serial Number (Read-Only) */}
          <label>Serial Number</label>
          <input
            type="text"
            value={serialNumber}
            disabled
            className="disabledInput"
          />
          <p className="inputNote">Use Add EVO to change serial numbers</p>
  
          {/* Description Field */}
          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={100}
            placeholder="Enter description"
          />
  
          {/* Error Message */}
          {error && <p className="error">{error}</p>}
  
          {/* Buttons */}
          <div className="buttonContainer">
            <button onClick={onClose}>Cancel</button>
            <button onClick={handleSave}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default EditProductModal;
